import React, { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Grid, Typography } from "@material-ui/core"
import { getEmailTags, getEmailsWithTags } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
import CommunicationNewEmail from "./CommunicationNewEmail"
import CommunicationEmailTable from "./CommunicationEmailTable"
import ManageTagsDialog from "./ManageTagsDialog"
import useStyles from "./styles"

const CommunicationEmail = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id, emailsWithTags = [], tags = [] } = useSelector(
    state => state.organization.currentOrg
  )
  const [openDialog, setOpenDialog] = useState(false)
  const [selectedEmail, setSelectedEmail] = useState()

  useEffect(() => {
    if (tags.length === 0) {
      dispatch(getEmailTags(id)).catch(() => {
        openSnackBar({ message: "Error getting email tags" })
      })
    }
  }, [id])

  useEffect(() => {
    if (emailsWithTags.length === 0) {
      dispatch(getEmailsWithTags(id)).catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error getting emails" }))
      })
    }
  }, [id])

  function toggleDialog() {
    setOpenDialog(status => !status)
  }

  return (
    <Fragment>
      <Typography variant="h5">Email</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <CommunicationNewEmail />
          <Button
            className={classes.manageTagsButton}
            variant="text"
            onClick={toggleDialog}
          >
            Manage tags
          </Button>
        </Grid>
        <Grid item xs={12} md={8}>
          <CommunicationEmailTable
            emailsWithTags={emailsWithTags}
            toggleDialog={toggleDialog}
            setSelectedEmail={setSelectedEmail}
          />
        </Grid>
      </Grid>
      <ManageTagsDialog
        openDialog={openDialog}
        toggleDialog={toggleDialog}
        selectedEmail={selectedEmail}
        setSelectedEmail={setSelectedEmail}
      />
    </Fragment>
  )
}

export default CommunicationEmail



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/index.jsx